"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22311],{

/***/ 22311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductVariantItem": function() { return /* binding */ ProductVariantItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(535874);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  gap: 8px;\n  margin-top: 2px;\n  display: grid;\n  grid-template-columns: repeat(3, minmax(80px, 1fr));\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: calc(100% - 32px); // 32px is the width of the image\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-word;\n  white-space: normal;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: -1px;\n  right: -1px;\n  width: 18px;\n  height: 18px;\n  background: #0200bc;\n  border-bottom-right-radius: ",
        ";\n  clip-path: polygon(100% 0, 0 100%, 100% 100%);\n\n  &::after {\n    content: '✔';\n    position: absolute;\n    bottom: -4px;\n    right: 2px;\n    font-size: 9px;\n    color: #fff;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  width: fit-content;\n  color: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





const ProductVariantItem = (param)=>{
    let { variant , onSelect , visible =true  } = param;
    var ref;
    const MAX_VARIANTS = 6;
    const { 0: showMore , 1: setShowMore  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    if (!((ref = variant.options) === null || ref === void 0 ? void 0 : ref.length)) return null;
    const filterOptions = (options)=>{
        return showMore ? options : options.slice(0, MAX_VARIANTS);
    };
    const handleShowMore = ()=>{
        setShowMore((prev)=>!prev);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Shape */ .b, {
        marginTop: "s8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
                level: 1,
                color: "textTitle",
                children: variant.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentWrapper, {
                children: filterOptions(variant.options).map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(OptionWrapper, {
                        href: "/".concat(option.url),
                        onClick: (e)=>{
                            e.preventDefault();
                            onSelect(option);
                        },
                        isActive: option.selected,
                        isVisible: visible,
                        blur: option.quantity === 0,
                        className: "att-variant-".concat(option.label, "-sku-").concat(option.sku),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .k, {
                                align: "center",
                                gap: "s8",
                                children: [
                                    option.imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w, {
                                        width: 32,
                                        height: 32,
                                        imageWidth: 32,
                                        src: option.imageUrl
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledVariantLabel, {
                                        children: option.label
                                    })
                                ]
                            }),
                            option.selected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Corner, {})
                        ]
                    }, index))
            }),
            variant.options.length > MAX_VARIANTS && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShowMore, {
                onClick: handleShowMore,
                children: showMore ? (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("R\xfat gọn") : (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Xem th\xeam")
            })
        ]
    });
};
const ContentWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject());
const OptionWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"])((next_link__WEBPACK_IMPORTED_MODULE_1___default()))((param)=>{
    let { isActive , theme , isVisible , blur  } = param;
    return "\n    border: 1px ".concat(isActive ? theme.colors.primary500 : theme.colors.divider, " solid;\n    position: relative;\n    color: ").concat(isActive ? theme.colors.primary500 : "black", ";\n    background-color: ").concat(isVisible || isActive === true ? "#fff" : "#e0e0e0", ";\n    cursor: ").concat(isVisible || isActive === true ? "pointer" : "not-allowed", ";\n    opacity: ").concat(blur ? "0.5" : "1", ";\n    min-width: 80px;\n    border-radius: 4px;\n    padding: 4px 8px;\n    text-decoration: none;\n");
});
const StyledVariantLabel = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].span(_templateObject1());
const Corner = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.borderRadius.s;
});
const ShowMore = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].div(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.link500;
}, (param)=>{
    let { theme  } = param;
    return theme.spacing.s4;
});


/***/ })

}]);